<template lang="pug">
  .b-notifications(:class="{ tile }" v-if="itemsRaw.length")
    ._header(v-if="!tile")
      BaseCheckbox._master-checkbox(
        :value="selected.length === itemsFiltered.length && itemsFiltered.length > 0"
        @change="$refs.selectableList.selectAll($event)"
      )
      ._header-btns
        Btn(sm :disabled="!selected.length" @click="viewNotifications") Прочитать
        Btn(sm :disabled="!selected.length" @click="deleteNotifications") Удалить
      ._tabs
        BaseTabs2(:items="tabs" v-model="filters.tab")
      ._project-filter
        BaseSelect(:options="projects" v-model="filters.project" notSelectedLabel="Все проекты" label="Все проекты")
      ._disable-sound
        Icon(name="no-sound" :class="{ active: soundDisabled }" pointer @click.native="toggleSound")
      router-link._settings(:to="{ name: 'notification-settings' }")
        Icon(name="setting" pointer)
    SelectableList._list(
      :autoreset="false"
      :items="itemsFiltered"
      v-slot="{ items, checked, toggle, enter, leave, down }"
      ref="selectableList"
      @change="selected = $event"
    )
      ._item(v-for="(item, i) in items" :class="{ new: !item.isViewed }" :key="item.id" @mouseenter="enter(i)")
        BaseCheckbox._checkbox(
          :value="checked.has(i)"
          @toggle="toggle(i, $event)"
          @mouseleave.native="leave(i)"
          @mousedown.native="down(i)"
        )
        NotificationComponentSelector._title(:item="item" type="title")
        ._project {{ item.info.projectName || item.info.projectId }}
        NotificationComponentSelector._icon(:item="item" type="icon")
        UserTile._initiator(:user="item.initiator")
          ._datetime {{ formatDate(item.createdAt) }}
        Icon._delete(name="close3" pointer @click.native="deleteNotification(item)")
  .no-notifications(v-else)
    img(src="/img/ghost.png")
    | Нет уведомлений
</template>

<script>
import utils from '@/utils/common';
import modelUserCustomSettings from '@/model/userCustomSettings';

import FormBlock from '@/components/FormBlock.vue';
import BaseSelect from '@/components/BaseSelect.vue';
import NotificationComponentSelector from '@/components/notification/NotificationComponentSelector.vue';
import UserTile from '@/components/UserTile.vue';
import form from '@/utils/form';
import BaseTabs2 from '@/components/BaseTabs2.vue';
import SelectableList from '@/components/ui/SelectableList.vue';
import BaseCheckbox from '@/components/BaseCheckbox.vue';

export default {
  name: 'NotificationList',
  props: {
    tile: Boolean,
  },
  components: {
    BaseCheckbox,
    SelectableList,
    BaseTabs2,
    FormBlock,
    BaseSelect,
    NotificationComponentSelector,
    UserTile,
  },
  data() {
    return {
      selected: [],
      filters: {
        project: null,
        tab: 'all',
      },
    };
  },
  mounted() {
    if (this.tile) return;

    if (this.unreadItemsCount) {
      this.filters.tab = 'unread';
    }
  },
  computed: {
    tabs() {
      return [
        { name: 'all', label: 'Все' },
        { name: 'unread', label: 'Непрочитанные', count: this.unreadItemsCount },
      ];
    },
    notificationSettings() { return this.$store.state.auth.user?.customSettings?.notifications ?? {}; },
    soundDisabled() { return this.notificationSettings?.soundDisabled === true; },
    itemsRaw() { return this.$store.state.notification.items; },
    unreadItemsCount() { return this.itemsRaw.filter(i => !i.isViewed).length; },
    itemsFiltered() {
      return this.itemsRaw
        .filter((i) => {
          const isSuitableByProject = !this.filters.project || this.filters.project === i.info.projectId?.toString();
          const isSuitableByView = this.filters.tab === 'all' || !i.isViewed;
          return isSuitableByProject && isSuitableByView;
        });
    },
    projects() {
      return form.makeSelectOptionsFromObject(
        this.itemsRaw.reduce((acc, val) => {
          // eslint-disable-next-line prefer-const
          let { projectId, projectName } = val.info;

          if (!projectName) projectName = projectId; // todo remove

          if (!acc[projectId]) {
            acc[projectId] = projectName;
          }

          return acc;
        }, {}),
      );
    },
  },
  watch: {
    filters: {
      handler() {
        this.$refs.selectableList.reset();
      },
      deep: true,
    },
  },
  methods: {
    formatDate(date) {
      return date ? utils.convertDateToString(new Date(date), 'short', true) : '';
    },
    async deleteNotification(item) {
      if (await this.$confirm('Удалить уведомление?')) {
        this.$store.dispatch('notification/delete', item);
      }
    },
    toggleSound() {
      const soundDisabled = !this.soundDisabled;
      const { notificationSettings } = this;
      modelUserCustomSettings.set({ notifications: { ...notificationSettings, soundDisabled } })
        .then(() => { this.$push({ text: `Звуковые оповещения ${soundDisabled ? 'выключены' : 'включены'}` }); });
    },
    getSelectedItemsAndReset() {
      const items = this.selected.map(i => this.itemsFiltered[i]);
      this.$refs.selectableList.reset();
      return items;
    },
    async viewNotifications() {
      const plural = utils.pluralWord(this.selected.length, 'уведомление', 'уведомления', 'уведомлений');
      if (await this.$confirm(`Отметить прочитанным ${plural}?`)) {
        const items = this.getSelectedItemsAndReset();
        items.filter(i => !i.isViewed).forEach(item => {
          this.$store.dispatch('notification/viewForce', item);
        });
      }
    },
    async deleteNotifications() {
      const plural = utils.pluralWord(this.selected.length, 'уведомление', 'уведомления', 'уведомлений');
      if (await this.$confirm(`Удалить ${plural}?`)) {
        const items = this.getSelectedItemsAndReset();
        items.forEach(item => {
          this.$store.dispatch('notification/delete', item);
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
  .notifications {
    padding-top: 0 !important;

    &__header {
      display: grid;
      grid-template-columns: min-content max-content 1fr 250px 40px 40px;
      padding-left: 25px;
      gap: 25px;
      align-items: center;
      margin-bottom: 15px;
    }

    &__header-btns {
      display: flex;
      gap: 10px;
      //flex-direction: column;
      align-items: flex-start;
    }

    &__disable-sound {
      align-self: center;
      justify-self: center;

      svg {
        height: 20px;
        fill: #99A3C5;
        &.active {
          fill: var(--color-accent);
        }
      }
    }

    &__settings {
      line-height: 0;

      svg {
        fill: #99A3C5;
        width: 26px;
        height: 26px;
      }
    }

    &__list {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    &__item {
      padding: 25px;
      display: grid;
      gap: 25px;
      grid-template-columns: 20px 1fr 230px 40px 250px 10px;
      border-radius: 6px;

      &:nth-child(odd) {
        background: #F5F7F9;
      }

      &.new {
        background: #EFF7FF;
        border-radius: 6px;
      }

      &:first-child, &.new, &.new + & {
        border-top: none !important;
      }
    }

    &__title::v-deep {
      color: var(--color-dark-gray);
      grid-row: 1 / 2 span;
      grid-column: 2;

      a {
        color: var(--color-accent) !important;
      }
    }

    &__checkbox {
      grid-column: 1;
    }

    &.tile &__checkbox {
      display: none;
    }

    &__icon {
      justify-self: center;
      align-self: center;
    }

    &__datetime {
      font-weight: normal;
      font-size: 12px;
      line-height: 15px;
      text-align: center;
      color: #788CA1;
      align-self: center;
    }

    &__delete {
      align-self: center;
    }

    @media (max-width: 1249px) {
      &__header {
        grid-template-columns: 20px 1fr 1fr 25px 25px;
        padding: 0;
      }

      &__master-checkbox {
        grid-row: 2;
        grid-column: 1;
      }

      &__header-btns {
        grid-row: 2;
        grid-column: 2 / 2 span;
      }

      &__project-filter {
        grid-row: 1;
        grid-column: 3 / 3 span;
      }

      &__tabs {
        grid-row: 1;
        grid-column: 1 / 2 span;
      }

      &:not(.tile) &__item {
        display: block;
        position: relative;
        padding: 17px 45px 16px;
        background: #F5F7F9;
      }

      &:not(.tile) &__icon {
        position: absolute;
        top: 16px;
        left: 15px;
      }

      &:not(.tile) &__delete {
        position: absolute;
        top: 24px;
        right: 16px;
      }

      &__project {
        font-size: 14px;
        line-height: 18px;
        margin: 22px 0 24px;
      }
    }

    &.tile &__list {
      max-height: 430px;
      overflow-y: auto;
      overflow-x: hidden;
      padding: 0 27px 0 25px;
      gap: 1px;

      &::-webkit-scrollbar { width: 5px; }
      &::-webkit-scrollbar-track { background: #F1F1F1; }
      &::-webkit-scrollbar-thumb { background: #C1C1C1; }
    }

    &.tile &__item {
      grid-template-columns: 20px 1fr 250px 10px;
      gap: 10px;
      align-items: center;
      justify-items: start;
      padding: 13px 0;
      border-radius: 0;
      border-top: 1px solid #D1D9F0;

      &:last-child {
        border-bottom: none;
      }

      &:last-child:not(.new) {
        border-bottom: 1px solid #D1D9F0;
      }

      &.new {
        background: #FFFFFF;
        position: relative;

        &:before, &:after {
          content: '';
          display: block;
          position: absolute;
          background: #FFFFFF;
          width: 25px;
          height: 100%;
          top: 0;
          bottom: 0;
        }

        &:before {
          right: 100%;
          border-radius: 8px 0 0 8px;
        }

        &:after {
          left: 100%;
          border-radius: 0 8px 8px 0;
        }
      }
    }

    &.tile &__title {
      font-weight: 500;
      font-size: 12px;
      line-height: 15px;
      grid-column: 2;
      grid-row: 1 / 1 span;
    }

    &.tile &__project {
      display: none;
    }

    &.tile &__icon {
      grid-column: 1;
    }

    &.tile &__initiator {
      display: block;
      &::v-deep {
        .name {
          font-size: 12px !important;
        }
        .avatar {
          width: 40px;
          height: 40px;
        }
      }
    }

    @media (max-width: 576px) {
      &__master-checkbox {
        grid-row: 3;
        grid-column: 1;
      }

      &__header-btns {
        grid-row: 3;
        grid-column: 2 / 4 span;
      }

      &__project-filter {
        grid-row: 2;
        grid-column: 1 / 5 span;
      }

      &__tabs {
        grid-row: 1;
        grid-column: 1 / 3 span;
      }
    }
    @media (max-width: 992px) {
      &.tile &__item {
        grid-template-columns: 20px 1fr 10px;
      }

      &.tile &__initiator {
        grid-row: 2;
        grid-column: 2;
      }
    }
  }

  .no-notifications {
    padding: 60px;
    border: 1px solid #EBEFF2;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    color: #99A3C5;

    img {
      margin-bottom: 15px;
    }
  }
</style>
